import { ReactNode } from 'react'

import {
  CalendarView,
  CustomView,
  HalfYearView,
  MonthView,
  QuarterView,
  YearView,
} from './components'
import { View, ViewComponentProps } from './DatePicker.types'

export const mobileAndTabletViewOptions = [
  { value: 'custom', title: 'Custom' },
  { value: 'month', title: 'Month' },
  { value: 'quarter', title: 'Quarter' },
  { value: 'half-year', title: 'Half-year' },
  { value: 'year', title: 'Year' },
] satisfies { value: View; title: string }[]

export const desktopViewOptions = [
  ...mobileAndTabletViewOptions,
  { value: 'calendar', title: 'Calendar' },
] satisfies { value: View; title: string }[]

export const viewComponents = {
  custom: CustomView,
  month: MonthView,
  quarter: QuarterView,
  'half-year': HalfYearView,
  year: YearView,
  calendar: CalendarView,
} satisfies Record<View, (props: ViewComponentProps) => ReactNode>
